import {decipher} from "../../utils/simpleCrypto";

export default async function me(fetch) {
    const resp = await fetch('/graphql', {
        body: JSON.stringify({
            query: '{me{id, email, p, earned}}',
        }),
    });

    const { data } = await resp.json();
    if (!data || !data.me) {
        return {
            id: null,
            email: null,
            p: false,
            isPro: false,
            earned: 0
        };
    }

    const user = data.me;
    const d = decipher(user.id + user.email);

    return {
        ...user,
        isPro: user.p && d(user.p) === 'jUkkA'
    }
}